import { WindowHelper } from '../WindowHelper';
import Cookie from './cookie';

export default class CookieButton extends Cookie {
    setTheCookie() {
        super.setCookie();
    }

    attachEvent() {
        document.querySelector(this.buttonQS).addEventListener(this.event, () => {
            this.setTheCookie();
            document.querySelector('.cookie-info').classList.add('is-hidden');
        }, true);
    }

    initButton(buttonQuerySelector) {
        this.buttonQS = buttonQuerySelector;
        this.event = 'click';
        if (!super.cookieWasAccepted()) this.attachEvent();
    }

    constructor(buttonQuerySelector) {
        super();
        if (WindowHelper.isElementThere(buttonQuerySelector)) this.initButton(buttonQuerySelector);
    }
}
